// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rounded-fifty[data-v-14382905]{border-radius:50%;width:24px;height:24px;line-height:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
